"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Bedroom = function Bedroom(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "21",
    height: "21",
    viewBox: "0 0 21 21"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    stroke: fill,
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.75 19.75V17.25C19.75 16.9185 19.6183 16.6005 19.3839 16.3661C19.1495 16.1317 18.8315 16 18.5 16H1V19.75"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 18.5H19.75"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 13.5H18.5V16H1V13.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.75 11H2.25C1.91848 11 1.60054 11.1317 1.36612 11.3661C1.1317 11.6005 1 11.9185 1 12.25V13.5H6V12.25C6 11.9185 5.8683 11.6005 5.63388 11.3661C5.39946 11.1317 5.08152 11 4.75 11Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 14.125V8.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.25 1H19.75V8.5H12.25V1Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 1V8.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.25 4.75H19.75"
  })));
};
Bedroom.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Bedroom.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Bedroom;